import { addTicketTypeData } from 'common/entities/ticketType';
import { APP } from '../index';

// Constants
export const TICKET_TYPE = 'ticketType';

// export const SET_TICKET_TYPE = `${APP}/SET_TICKET_TYPE`;
export const SET_TICKET_TYPE_ID = `${APP}/SET_TICKET_TYPE_ID`;
export const DELETE_TICKET_TYPE_ID = `${APP}/DELETE_TICKET_TYPE_ID`;

// Reducers
export const INIT_STATE = {
    ticketTypeIds: [],
};

export const reducers = {
    [SET_TICKET_TYPE_ID](state, { payload }) {
        return {
            ...state,
            ticketTypeIds: state.ticketTypeIds.includes(payload)
                ? state.ticketTypeIds
                : [...state.ticketTypeIds, payload],
        };
    },
    [DELETE_TICKET_TYPE_ID](state, { payload }) {
        return {
            ...state,
            ticketTypeIds: [...state.ticketTypeIds.filter((ticketTypeId) => ticketTypeId !== payload)],
        };
    },
};

// Actions
export const setTicketTypeId = (id) => ({
    type: SET_TICKET_TYPE_ID,
    payload: id,
});

export const deleteTicketType = (id) => ({
    type: DELETE_TICKET_TYPE_ID,
    payload: id,
});

export const setEventTicketTypes = (ticketTypes) => (dispatch) => {
    (ticketTypes || []).forEach((ticketType) => {
        dispatch(addTicketTypeData(ticketType));
        dispatch(setTicketTypeId(`${ticketType.ticketId}`));
    });
};

// App module
export default {
    initialState: INIT_STATE,
    reducers,
};
